export default __webpack_public_path__ + "static/media/ic5.b3a29c7e.gif";